import React from 'react';

export const Accomplishments = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g mask="url(#mask0_70_2621)">
      <path
        d="M5.83337 1.66675H14.1667V8.20842C14.1667 8.52786 14.0973 8.81258 13.9584 9.06258C13.8195 9.31258 13.625 9.51397 13.375 9.66675L10.4167 11.4167L11 13.3334H14.1667L11.5834 15.1667L12.5834 18.3334L10 16.3751L7.41671 18.3334L8.41671 15.1667L5.83337 13.3334H9.00004L9.58337 11.4167L6.62504 9.66675C6.37504 9.51397 6.1806 9.31258 6.04171 9.06258C5.90282 8.81258 5.83337 8.52786 5.83337 8.20842V1.66675ZM7.50004 3.33341V8.20842L9.16671 9.20841V3.33341H7.50004ZM12.5 3.33341H10.8334V9.20841L12.5 8.20842V3.33341Z"
        fill={color || '#7D7A9A'}
      />
    </g>
  </svg>
);
